import PropTypes from "prop-types";
import { ITXImage } from "components/ITXImage";

export default function MediaLogo({ id, name, logo_width, logo_height }) {
  return (
    <ITXImage
      id={id}
      name={name}
      width={logo_width || 476}
      height={logo_height || 225}
      className={`geco-media_logo logo-${id}`}
    />
  );
}

MediaLogo.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  logo_width: PropTypes.number,
  logo_height: PropTypes.number,
};
